import { render } from "./PageLoading.vue?vue&type=template&id=4527324c&scoped=true&ts=true"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"

import "./PageLoading.vue?vue&type=style&index=0&id=4527324c&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4527324c"]])

export default __exports__